import React, { useState } from 'react';
import { List, Tag } from 'antd';
import { RightOutlined } from '@ant-design/icons';
import styles from './index.module.less';
import { useConfigProvider } from '@/context/ConfigProvider';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '@/lib/hooks/utils/utils';

export default function PlatformDetails({ platformData, getRow }: { platformData: any; getRow: (row: any) => void }) {
  const [expandedIndex, setExpandedIndex] = useState<number | null>(null);
  const { isMobile } = useConfigProvider();
  const { t } = useTranslation();
  const handleItemClick = (index: number, row: any) => {
    if (isMobile) {
      getRow(row);
    } else {
      setExpandedIndex(expandedIndex === index ? null : index);
    }
  };
  const truncateText = (text: string, maxLength: number) => {
    return text.length > maxLength ? text.slice(0, maxLength) + '...' : text;
  };
  const getInnerHtml = (text: string) => {
    if (isMobile) {
      return truncateText(capitalizeFirstLetter(t(text)), 20).replaceAll(/[\d$%.\-\/]+/g, '<span >$&</span>');
    } else {
      return capitalizeFirstLetter(t(text)).replaceAll(/[\d$%.\-\/]+/g, '<span>$&</span>');
    }
  };

  return (
    <div className={styles.platformDetails}>
      <List
        className={styles.detailsList}
        dataSource={platformData}
        renderItem={(item: any, index) => (
          <List.Item
            className={`${styles.detailItem} ${expandedIndex === index ? styles.expanded : ''}`}
            onClick={() => handleItemClick(index, item)}
          >
            <div className={styles.itemContent}>
              <span>
                <div
                  dangerouslySetInnerHTML={{
                    __html: getInnerHtml(item.value),
                  }}
                ></div>
              </span>
              <div className={styles.itemHeader}>
                <RightOutlined className={`${styles.itemArrow} ${expandedIndex === index ? styles.rotated : ''}`} />
              </div>
            </div>
            {expandedIndex === index && (
              <div className={styles.itemDetail}>
                <div>{t(item.value)}</div>
                <div>{capitalizeFirstLetter(t(item.detail))}</div>
              </div>
            )}
          </List.Item>
        )}
      />
    </div>
  );
}
